<template>
  <div class="add_body">

    <van-field v-model="tel" type="tel" label="请输入姓名" />


    <div class="baocun"><van-button type="primary" block>保存</van-button></div>
  </div>
</template>

<script>
    export default {
        name: "add_body",
        data(){
            return{
                tel: '',
            }
        },
        created() {

        },
        methods:{

        }
    }
</script>

<style scoped lang="stylus">
  .add_body{
    position relative;
  }
  .baocun{
    width 100%;
    position fixed;
    bottom 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/wode/certification.vue